import PropTypes from 'prop-types'

import style from '@aytm/app/stats/page/question-views/components/questions-custom/styles/ReloadScreen.module.scss'

// Drawn over a data-lab partial whose answer no longer matches what the researcher asked for: the
// report has to be re-run before anything underneath means what it says. The partial element is
// the positioned ancestor, so this needs no wrapper of its own.
const ReloadScreen = ({ reloadNeeded }) =>
  reloadNeeded ? (
    <div className={style.screen} data-reload-screen data-testid="stat-dl-reload-screen">
      <div className={style.note}>Reload needed</div>
    </div>
  ) : null

ReloadScreen.propTypes = {
  reloadNeeded: PropTypes.bool
}

export default ReloadScreen
